export var carouselExtensionType = 'com.atlassian.confluence.carousel';
export var carouselExtensionKey = 'carousel';
export var carouselContentAnalyticSource = 'carouselExtension';
export var carouselConfigAnalyticSource = 'carouselExtensionConfig';
export var AUTOPLAY_SECONDS = 8;
export var ARIA_CONTROLS_PREFIX = 'carousel-navigation-frame-';
export var CAROUSEL_VERSION_1 = '1';
export var CAROUSEL_VERSION_2 = '2';
export var FRAMES_LIMIT_V2 = 10;